import { RaceBy } from "@uiball/loaders";
import Flexbox from "../../components/Flexbox";
import Mode from "../../components/styles/Mode";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import requests from "../../handlers/requests";
import '../../css/form.css'
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";
import { useNavigate } from "react-router-dom";
import { BuyersTYUrl, extractUTMParameters } from "../../utilities/utils";

const Lead = () => {
    const mode = useSelector(state => state.darkmode.value)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(true)

    const [error,] = useState(null)
    const sendToBuyers = (id, source, page, stop) => {
        setLoading(true)
        const params = `page=${page}` + extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])

        requests.post(`/api/${source}/lead`, { contact_id: id, url_params: params }, () => { }, () => { }, () => { }, setLoading,
            (res) => {
                const user = res.data
                const ty_page = BuyersTYUrl.get(res.buyer).replaceAll('-valid', '') // https://www.finaldebt.com/success-valid-[buyer]- = https://www.finaldebt.com/success-[buyer]- |  https://www.finaldebt.com/success-[buyer]-

                const full_url = `${ty_page}${page}1?first_name=${user.first_name}&last_name=${user.last_name}&debt_amount=${user.debt_amount}&phone=${user.phone}&email=${user.email}&zip=${user.zipcode}&url=${res.url ?? ''}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`

                // send to buyer's thank you page
                window.location.replace(full_url)
            },
            null,
            (res) => {
                // handle error

                if (res.error.includes('Duplicate')) {
                    window.location.replace(`https://www.finaldebtrelief.com/dup-error-${page}1?first_name=${res.data.first_name}&last_name=${res.data.last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
                    // TODO => uncomment when cura is approved
                    // navigate(`/cura?contact_id=${res.data.contact_id}&source=${source}&page=${page}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
                } else if (res.msg.includes('no coverage in') || res.msg.includes('Outside') || res.msg.includes('DNC')) {
                    window.location.replace(`https://www.finaldebtrelief.com/dq-${page}1?first_name=${res.data.first_name}&last_name=${res.data.last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
                    // TODO => uncomment when cura is approved
                    // navigate(`/cura?contact_id=${res.data.contact_id}&source=${source}&page=${page}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
                } else {
                    navigate(`/lead-form?contact_id=${res.data.contact_id}&firstname=${res.data.first_name}&lastname=${res.data.last_name}&email=${res.data.email}&phone=${res.data.phone}&saved=true&error=Could not complete request. please try again!&page=${page}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`, { replace: true })
                }
            }
        )
    }


    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        const urlParams = new URLSearchParams(window.location.search)
        const contact_id = urlParams.get('contact_id')
        const source = urlParams.get('source')
        const page = urlParams.get('page')

        sendToBuyers(contact_id, source, page, false)
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="turbo-debt-page">
                {loading && <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                    <RaceBy size={40} speed={0.9} color={mode.dark ? "white" : "black"} />
                </Flexbox>}
                {error && (
                    <div>
                        <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                            {error}
                        </Flexbox>
                    </div>
                )}
            </div>
        </Mode>
    );
}

export default Lead;